import { Input, Select as AntSelect } from 'antd';
import { useFormik } from 'formik';
import styled from 'styled-components';

import { SHIPPING_METHOD_LABEL, SHIPPING_METHOD } from '@frontend/api';

import {
  SHIPPING_CARRIER,
  SHIPPING_CARRIER_LABEL,
  SHIPPING_GROUPING,
} from 'constants/all';

import { SHIPPING_GROUPING_LABEL } from '../constants';

const Option = AntSelect.Option;

const Select = styled(AntSelect)``;

const Error = styled.div`
  color: #ed1d39;
`;

const CustomerAccountDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 12px;
  margin-bottom: 15px;

  ${Select} {
    width: 100%;
  }

  > * {
    margin-top: 5px;
    margin-right: 15px;
  }
`;

const ShippingAccountForm = ({
  values,
  handleChange,
  touched,
  errors,
  setFieldValue,
}: Pick<
  ReturnType<typeof useFormik>,
  'values' | 'handleChange' | 'touched' | 'errors' | 'setFieldValue'
>) => {
  return (
    <CustomerAccountDetails>
      <div>
        <div>Shipping Account #:</div>
        <Input
          name="customerAccount"
          value={values.customerAccount}
          onChange={handleChange}
        />
        {touched.customerAccount && errors.customerAccount && (
          <Error>{errors.customerAccount as string}</Error>
        )}
      </div>
      <div>
        <div>Carrier:</div>
        <Select
          value={values.customerCarrier}
          onChange={(value) => setFieldValue('customerCarrier', value)}
        >
          <Option value={SHIPPING_CARRIER.UPS}>
            {SHIPPING_CARRIER_LABEL[SHIPPING_CARRIER.UPS]}
          </Option>
          <Option value={SHIPPING_CARRIER.FEDEX}>
            {SHIPPING_CARRIER_LABEL[SHIPPING_CARRIER.FEDEX]}
          </Option>
        </Select>
      </div>
      <div>
        <div>Method:</div>
        <Select
          value={values.method}
          onChange={(value) => setFieldValue('method', value)}
        >
          <Option value={SHIPPING_METHOD.EARLY_OVERNIGHT}>
            {SHIPPING_METHOD_LABEL[SHIPPING_METHOD.EARLY_OVERNIGHT]}
          </Option>
          <Option value={SHIPPING_METHOD.ONE_DAY}>
            {SHIPPING_METHOD_LABEL[SHIPPING_METHOD.ONE_DAY]}
          </Option>
          <Option value={SHIPPING_METHOD.TWO_DAY}>
            {SHIPPING_METHOD_LABEL[SHIPPING_METHOD.TWO_DAY]}
          </Option>
          <Option value={SHIPPING_METHOD.GROUND}>
            {SHIPPING_METHOD_LABEL[SHIPPING_METHOD.GROUND]}
          </Option>
        </Select>
        {touched.method && errors.method && (
          <Error>{errors.method as string}</Error>
        )}
      </div>
      <div>
        <div>Ship Line Items:</div>
        <Select
          value={values.grouping}
          onChange={(value) => setFieldValue('grouping', value)}
          disabled={true}
        >
          <Option value={SHIPPING_GROUPING.BULK}>
            {SHIPPING_GROUPING_LABEL[SHIPPING_GROUPING.BULK]}
          </Option>
          <Option value={SHIPPING_GROUPING.BY_LEAD_TIME}>
            {SHIPPING_GROUPING_LABEL[SHIPPING_GROUPING.BY_LEAD_TIME]}
          </Option>
        </Select>
      </div>
    </CustomerAccountDetails>
  );
};

export default ShippingAccountForm;
